export default "__VITE_ASSET__BHZO9pLd__"